import type { Equipment } from '@/types';

export const EQUIPMENT: Equipment[] = [
  { id: 'dumbbells',     n: 'Haltères',           emoji: '🏋️' },
  { id: 'bench',         n: 'Banc de muscu',      emoji: '🛋️' },
  { id: 'pullup_bar',    n: 'Barre de traction',  emoji: '⬛' },
  { id: 'punching_bag',  n: 'Sac de boxe',        emoji: '🥊' },
  { id: 'gloves',        n: 'Gants de boxe',      emoji: '🧤' },
  { id: 'jump_rope',     n: 'Corde à sauter',     emoji: '🪢' },
  { id: 'bike',          n: 'Vélo',               emoji: '🚴' },
  { id: 'kettlebell',    n: 'Kettlebell',         emoji: '🔔' },
  { id: 'bands',         n: 'Élastiques',         emoji: '〰️' },
  { id: 'medicine_ball', n: 'Ballon lesté',       emoji: '⚪' },
  { id: 'barbell',       n: 'Barre olympique',    emoji: '🏋️‍♂️' },
  { id: 'foam_roller',   n: 'Rouleau massage',    emoji: '🧻' },
];
